export default __webpack_public_path__ + "static/media/03.2692f9c9.jpg";